// import setKioskGraphqlMutation from '~layers/app/graphql/cart/setKiosk.gql'

export function useKiosk() {
  const stores: { value: string, label: string }[] = [
    { value: '', label: 'Select store' },
    { value: 'groningen', label: 'Groningen' },
    { value: 'zwolle', label: 'Zwolle' },
    { value: 'deventer', label: 'Deventer' },
    { value: 'hardenberg', label: 'Hardenberg' },
    { value: 'almelo', label: 'Almelo' },
    { value: 'vakantiebeurs', label: 'Vakantiebeurs' },
  ]

  const watchersEnabled = useState('kiosk-watchers-enabled', () => false)
  const { getCartId } = useCart()

  const kiosk = useCookie('kiosk', {
    maxAge: 60 * 60 * 24 * 60,
    watch: true,
  })

  const label = computed<string>(() =>
    stores.find(({ value }: { value: string }) => value === kiosk.value)?.label || '',
  )

  // const {
  //   mutate: setKioskMutation,
  //   error: setKioskError,
  // } = useMutation(
  //   setKioskGraphqlMutation,
  //   { clientId: 'customer' },
  // )

  const setKioskError = ref()
  const setKiosk = async (selectedValue: string): Promise<boolean | null> => {
    kiosk.value = selectedValue
    refreshCookie('kiosk')

    if (getCartId.value) {
      // await setKioskMutation({ cartId: getCartId.value, kiosk: kiosk.value })

      const result = await useGraphqlMutation('setGuestEmailOnCart', { cartId: getCartId.value, kiosk: kiosk.value }, useGraphqlCustomerClient())

      if (result.errors?.length) {
        setKioskError.value = result.errors?.[0]
      }

      return !setKioskError.value
    }
    return null
  }

  if (!watchersEnabled.value) {
    watchersEnabled.value = true
    watch(getCartId, (newVal, oldVal) => {
      if (kiosk.value && !oldVal && newVal) {
        // setKioskMutation({ cartId: getCartId.value, kiosk: kiosk.value })
        useGraphqlMutation('setGuestEmailOnCart', { cartId: getCartId.value, kiosk: kiosk.value }, useGraphqlCustomerClient())
      }
    })
  }

  return {
    stores,
    label,
    kiosk,
    setKiosk,
  }
}
